import script from "./HistoryListComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryListComponent.vue?vue&type=script&setup=true&lang=ts"

import "./HistoryListComponent.vue?vue&type=style&index=0&id=2e0b9eaa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e0b9eaa"]])

export default __exports__